var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgInvertedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8319_44224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 24.5C19.0024 24.5 24.375 19.1274 24.375 12.5C24.375 5.87258 19.0024 0.5 12.375 0.5C5.74758 0.5 0.375 5.87258 0.375 12.5C0.375 19.1274 5.74758 24.5 12.375 24.5Z",
    fill: "#00AB58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3776 4.30078L17.375 9.36523L12.3754 14.4266L10.3752 12.4021L13.3752 9.36523L12.3754 8.35273L8.37509 12.4021L12.3754 16.4514L18.3752 10.3772L20.375 12.4021L12.3754 20.5008L4.375 12.4021L12.3776 4.30078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3734 24.1004C18.7799 24.1004 23.9734 18.9069 23.9734 12.5004C23.9734 6.09389 18.7799 0.900391 12.3734 0.900391C5.96693 0.900391 0.773438 6.09389 0.773438 12.5004C0.773438 18.9069 5.96693 24.1004 12.3734 24.1004Z",
    stroke: "#00AB58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8319_44224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgInvertedLight);
export default __webpack_public_path__ + "static/media/NRGInvertedLight.e86aad46494a50f9c69b714eff9cae87.svg";
export { ForwardRef as ReactComponent };